import React, { useState, useEffect } from "react";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";

import DataTable from "react-data-table-component";
import { dashboardColors, theme } from "../../themes/Theme";

const DataTableCustom = ({
	columns,
	rowData,
	sortField,
	handleRowChange,
	selectableRows,
	search,
	noDataComponent,
	pagination,
	conditionalRowStyles,
	onSelectedRowsChange,
	clearSelected,
	highlightOnHover,
	className
}) => {
	return (
		<div className={`${className ? className : "mt-3"}`}>
			{search != "NotNeeded" ? (
				<div className="referralDisplay">
					<DataTableExtensions
						columns={columns}
						data={rowData}
						print={false}
						export={false}
						filterPlaceholder="Search...">
						<DataTable
							customTheme={myTheme}
							// selectableRowsComponent={Checkbox}
							columns={columns}
							data={rowData}
							// defaultSortField={sortField}
							responsive
							noDataComponent={noDataComponent}
							pointerOnHover={false}
							Clicked
							pagination={pagination}
							highlightOnHover={highlightOnHover}
							conditionalRowStyles={conditionalRowStyles}
							selectableRows={selectableRows}
							onSelectedRowsChange={onSelectedRowsChange}
							clearSelectedRows={clearSelected}
							// onSelectedRowsChange={state => {
							// 	setCheckboxArray(state.selectedRows);
							// }}
							onRowClicked={handleRowChange}
							// clearSelectedRows={clearSelected}
						/>
					</DataTableExtensions>
				</div>
			) : (
				<DataTable
					customTheme={myTheme}
					// selectableRowsComponent={Checkbox}
					columns={columns}
					data={rowData}
					defaultSortField={sortField}
					responsive
					noDataComponent={noDataComponent}
					pointerOnHover={true}
					Clicked
					pagination={pagination}
					highlightOnHover={highlightOnHover}
					conditionalRowStyles={conditionalRowStyles}
					// onSelectedRowsChange={state => {
					// 	setCheckboxArray(state.selectedRows);
					// }}
					onRowClicked={handleRowChange}
					selectableRows={selectableRows}
					onSelectedRowsChange={onSelectedRowsChange}
					clearSelectedRows={clearSelected}

					// clearSelectedRows={clearSelected}
				/>
			)}

			<style jsx>{`
				.rdt_TableCell {
					font-size: 14px !important;
					justify-content: center;
					text-align: center;
				}

				.rdt_TableCol {
					height: 100%;
					text-align: center;
					justify-content: center;
				}

				.rdt_TableCol_Sortable {
					text-align: center;
					justify-content: center;
					font-weight: bold;
					margin-left: 16px;
					font-size: 14px;
				}

				.rdt_TableHeader + div {
					scrollbar-width: thin;
					overflow-x: auto; 
					overflow-y: hidden;
					scrollbar-color: #888 transparent;
				}

				.rdt_TableHeader {
					display: none;
				}

				.rdt_TableHeadRow {
					background: #f5f5f0 !important;
					color: black;
				}

				// Filter
				.data-table-extensions-filter {
					width: 100%;
				}

				.data-table-extensions > .data-table-extensions-filter > .icon {
					margin: 2px 2px 2px 4px !important;
					color: red !important;
				}

				.data-table-extensions-filter label {
					float: right !important;
					color: black !important;
				}

				.data-table-extensions-filter input {
					width: 80%;
				}

				@media (min-width: 991px) {
					.referralDisplay {
						transform: translateY(-60px);
					}

					.data-table-extensions-filter {
						border: 1.5px solid  var(--primaryColor);
						width: 25%;
						transform: translateX(-100px);
						border-radius: 4px;
						height: 2.25em;
						float: right !important;
						display: block;
					}
				}
			`}</style>
		</div>
	);
};

const myTheme = {
	title: {
		fontSize: "22px",
		fontColor: "#1f2933",
		fontWeight: "800",
		backgroundColor: "transparent",
		height: "56px"
	},
	header: {
		fontSize: "15px",
		fontWeight: "500",
		fontColor: "#FFFFFF",
		fontColorActive: "#FFFFFF",
		backgroundColor: dashboardColors[theme].primary,
		height: "48px",
		denseHeight: "32px",
		cellPaddingLeft: "0px"
	},
	contextMenu: {
		backgroundColor: "#e3f2fd",
		fontSize: "18px",
		fontColor: "rgba(0,0,0,.87)",
		transitionTime: "225ms"
	},
	rows: {
		// default || spaced
		spacing: "default",
		fontSize: "14px",
		fontColor: "hsl(0, 0%, 29%)",
		backgroundColor: "white",
		borderWidth: "1px",
		borderColor: "#ececec",
		stripedColor: "BCBFC2",
		hoverFontColor: "#000000",
		hoverBackgroundColor: "#C1C4C6",
		hoverBorderColor: "#8F86FF",
		height: "48px",
		denseHeight: "32px"
	},
	cells: {
		cellPadding: "48px",
		fontWeight: "600 !imprtant ",
		maxWidth: "200px"
	},
	expander: {
		fontColor: "rgba(0,0,0,.87)",
		expanderColor: "rgba(0,0,0,.54)",
		expanderColorDisabled: "rgba(0,0,0,.12)",
		backgroundColor: "transparent"
	},
	pagination: {
		fontSize: "13px",
		fontColor: "rgba(0,0,0,.54)",
		backgroundColor: "transparent",
		buttonFontColor: "rgba(0,0,0,.54)",
		buttonHoverBackground: "rgba(0,0,0,.12)"
	},

	columnDefs: [{ width: "20%", targets: 0 }]
};

export default DataTableCustom;
